import { api } from "../store/middleware/api";
// const authToken = localStorage.getItem("token")
const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    addSubscription: build.mutation({
      query: (body) => ({
        url: `/subcription/add`,
        // url: `http://localhost:5055/api/subcription/add`,
        method: "POST",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        //   // Add other headers if needed
        // },
        body,
      }),
    }),
    getSubscriptionStatus: build.query({
      query: () => "/subcription/active",
    }),
    getSubscriptionCancel: build.mutation({
      query: (body) => ({
        url: "/subcription/cancel",
        method: "POST",
        body,
      }),
    }),
    getSubscriptionpause: build.mutation({
      query: (body) => ({
        url: "/subcription/pause",
        method: "POST",
        body,
      }),
    }),
    subscriptionUpdate: build.mutation({
      query: (body) => ({
        url: "/subcription/update",
        method: "POST",
        body,
      }),
    }),
    getAllSubscriptions: build.query({
      query: (id) => ({
        url: `/subcription`,
        // url: "http://localhost:5055/api/subcription",
        method: "POST",
        body: { "_id": id },
        // headers: {
        //     Authorization: `Bearer ${authToken}`,
        //     // Add other headers if needed
        // },

      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddSubscriptionMutation,
  useGetSubscriptionStatusQuery,
  // useGetSubscriptionCancelQuery,
  useGetSubscriptionCancelMutation,
  useGetSubscriptionpauseMutation,
  // useGetSubscriptionpauseQuery,
  useSubscriptionUpdateMutation,
  useGetAllSubscriptionsQuery
} = extendedApi;
